// FAQSection.jsx
import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import '../../../../assets/css/customer/subscreens/contact/FAQSection.css';
import MyContext from '../../../../contexts/AppContext';

const FAQSection = () => {
  const { baseUrl } = useContext(MyContext);
  const [faqs, setFaqs] = useState([]);

const viewAllFaqs= () => {
    axios.get(`${baseUrl}/customer/faq/viewAllFaqs`)
      .then((response) => {
        console.log(response.data);
        setFaqs(response.data.faq);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllFaqs();
  }, []);


  return (
    <section className="faq-section">
      <Container>
        <h2 className="section-title-center">Frequently Asked Questions</h2>
        <Row className="faq-grid">
          {faqs.map((faq, index) => (
            <Col lg={6} md={12} key={index}>
              <div className="faq-item">
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;